import React, { useEffect, useState } from "react";
import {
	Form,
	Button,
	Popconfirm,
	message,
	Modal,
	Spin,
	Switch,
	Table,
	Input,
} from "antd";
import {
	useGetDriversQuery,
	useAddDriverMutation,
	useDeleteDriverMutation,
	useUpdateDriverMutation,
} from "@/redux/services/driverApi";

const Add = () => {
	const [form] = Form.useForm();
	const [isOpen, setIsOpen] = useState(false);

	const [addDriver] = useAddDriverMutation();
	const { refetch } = useGetDriversQuery();

	const onFinish = async (values) => {
		// try {
		// 	await addDriver({
		// 		...values,
		// 		role_id: 3,
		// 	}).unwrap();
		// 	await refetch();
		// 	form.resetFields();
		// 	setIsOpen(false);
		// 	message.success("Create successful");
		// } catch (error) {
		// 	message.error("Something went wrong...");
		// }

		await addDriver({
			...values,
			role_id: 3,
		})
			.unwrap()
			.then((payload) => {
				refetch();
				form.resetFields();
				setIsOpen(false);
				message.success("Create successful");
			})
			.catch((error) => message.error("Something went wrong..."));
	};

	const handleCancel = () => {
		form.resetFields();
		setIsOpen(false);
	};

	return (
		<div>
			<Button
				style={{ marginBottom: "30px" }}
				onClick={() => setIsOpen(true)}
			>
				新司机
			</Button>
			<Modal
				title="Create A Vehicle"
				open={isOpen}
				onCancel={handleCancel}
				footer={[
					<Button key="cancel" onClick={handleCancel}>
						Cancel
					</Button>,
				]}
				width="60%"
			>
				<Form
					form={form}
					onFinish={onFinish}
					labelCol={{ span: 8 }}
					wrapperCol={{ span: 16 }}
					style={{ maxWidth: 600, marginTop: "30px" }}
				>
					<Form.Item
						name="user_name"
						label="名字"
						rules={[{ required: true, message: "请输入名字" }]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="user_email"
						label="Email"
						rules={[{ required: true, message: "请输入邮件" }]}
					>
						<Input />
					</Form.Item>

					<Form.Item
						name="user_phone"
						label="电话"
						rules={[{ required: true, message: "请输入电话" }]}
					>
						<Input />
					</Form.Item>

					<Form.Item wrapperCol={{ offset: 8, span: 16 }}>
						<Button type="primary" htmlType="submit">
							Submit
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
};

const Edit = ({ item, isOpen, handleClose }) => {
	const [form] = Form.useForm();
	const [updateDriver] = useUpdateDriverMutation();

	const handleCancel = () => {
		handleClose();
	};

	const onFinish = async (values) => {
		try {
			await updateDriver({
				...values,
				user_detail_id: item.user_detail_id,
			});
			message.success("Update successful");
			handleCancel();
		} catch (error) {
			message.error("Something went wrong...");
		}
		// await updateDriver({
		// 	...values,
		// 	user_detail_id: item.user_detail_id,
		// })
		// 	.unwrap()
		// 	.then((payload) => {
		// 		message.success("Update successful");
		// 		handleCancel();
		// 	})
		// 	.catch((error) => message.error("Something went wrong..."));
	};

	useEffect(() => {
		form.setFieldsValue(item); // 确保每次 item 更新时，更新表单的字段值
	}, [form, item]);

	return (
		<div>
			<Modal
				title="Edit Driver"
				open={isOpen}
				onCancel={handleCancel}
				footer={[
					<Button key="cancel" onClick={handleCancel}>
						Cancel
					</Button>,
				]}
				width="60%"
			>
				<Form
					form={form}
					onFinish={onFinish}
					labelCol={{ span: 8 }}
					wrapperCol={{ span: 16 }}
					style={{ maxWidth: 600, marginTop: "30px" }}
					initialValues={item}
				>
					<Form.Item
						name="user_name"
						label="名字"
						rules={[{ required: true, message: "请输入名字" }]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="user_email"
						label="Email"
						rules={[{ required: true, message: "请输入邮件" }]}
					>
						<Input />
					</Form.Item>

					<Form.Item
						name="user_phone"
						label="电话"
						rules={[{ required: true, message: "请输入电话" }]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="user_status"
						label="状态"
						rules={[{ required: true, message: "请选择司机状态" }]}
					>
						<Switch />
					</Form.Item>

					<Form.Item wrapperCol={{ offset: 8, span: 16 }}>
						<Button type="primary" htmlType="submit">
							Submit
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
};

const Driver = () => {
	const { data, isLoading, isError, refetch } = useGetDriversQuery();
	const [deleteDriver] = useDeleteDriverMutation();
	const [isOpenEdit, setIsOpenEdit] = useState(false);
	const [editItem, setEditItem] = useState();

	const handleClose = async () => {
		await refetch();
		setIsOpenEdit(false);
		setEditItem(undefined);
	};

	const handleDelete = async (item) => {
		try {
			await deleteDriver(item.user_detail_id);
			message.success(`${item.user_email} delete successful!`);
			refetch();
		} catch (error) {
			message.error("something went wrong");
			console.log("error", error);
		}

		// await deleteDriver(item.user_detail_id)
		// 	.unwrap()
		// 	.then((payload) => {
		// 		message.success("delete successful");
		// 		refetch();
		// 	})
		// 	.catch((error) => message.error("Something went wrong..."));
	};

	const columns = [
		// {
		// 	title: "ID",
		// 	dataIndex: "user_detail_id",
		// 	key: "user_detail_id",
		// 	editable: false,
		// },
		{
			title: "Email",
			dataIndex: "user_email",
			key: "user_email",
			editable: true,
		},
		{
			title: "名字",
			dataIndex: "user_name",
			key: "user_name",
			editable: true,
		},
		{
			title: "电话",
			dataIndex: "user_phone",
			key: "user_phone",
			editable: true,
		},
		{
			title: "状态",
			dataIndex: "user_status",
			key: "user_status",
			editable: true,
			render: (item) => {
				return <>{item ? "Available" : "Unavailable"}</>;
			},
		},
		{
			title: "修改",
			dataIndex: "",
			key: "x",
			render: (item) => {
				return (
					<Button
						onClick={() => {
							setIsOpenEdit(true);
							setEditItem(item);
						}}
					>
						Edit
					</Button>
				);
			},
		},
		{
			title: "删除",
			dataIndex: "",
			key: "x",
			render: (item) => {
				return (
					<Popconfirm
						title="Delete the driver"
						description="Are you sure to delete this driver?"
						onConfirm={() => handleDelete(item)}
						okText="Yes"
						cancelText="No"
					>
						<Button danger>Delete</Button>
					</Popconfirm>
				);
			},
		},
	];

	if (isLoading) {
		return <Spin />;
	}

	if (isError) {
		return <div>something went wrong</div>;
	}
	return (
		<div>
			<Add />
			<Table dataSource={data} columns={columns} />
			<Edit
				handleClose={handleClose}
				isOpen={isOpenEdit}
				item={editItem}
			/>
		</div>
	);
};

export default Driver;
